import React from "react";
import classNames from "classnames";

import "./text.scss";

export function Text({ className, children }) {
  return <span className={classNames("text", className)}>{children}</span>;
}
